import { render, staticRenderFns } from "./DateMessageBalloon.vue?vue&type=template&id=0e0507dc&scoped=true&"
import script from "./DateMessageBalloon.vue?vue&type=script&lang=js&"
export * from "./DateMessageBalloon.vue?vue&type=script&lang=js&"
import style0 from "./DateMessageBalloon.vue?vue&type=style&index=0&id=0e0507dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0507dc",
  null
  
)

export default component.exports